export * from "./Modal";
export { ModalTrigger } from "./styled";
